/**
 * @flow
 * @relayHash d56af2fa246fd276073dc2ed4e4d129d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AccountStatus = "ACCOUNT_APPROVED" | "ACCOUNT_CLOSED" | "ACCOUNT_CLOSING" | "ACCOUNT_CONTINUED_ISA" | "ACCOUNT_DECEASED" | "ACCOUNT_NOT_INITIATED" | "ACCOUNT_PENDING" | "ACCOUNT_SUBMITTED" | "ACCOUNT_SUSPENDED" | "ACCOUNT_TRADING_SUSPENDED" | "ACCOUNT_VOIDED_ISA" | "%future added value";
export type CloseAccountMutationVariables = {|
  accountId: string
|};
export type CloseAccountMutationResponse = {|
  +closeAccount: ?{|
    +account: ?{|
      +id: string,
      +updatedAt: any,
      +clientaccount: ?{|
        +id: string,
        +accountStatus: AccountStatus,
        +updatedAt: any,
      |},
    |}
  |}
|};
export type CloseAccountMutation = {|
  variables: CloseAccountMutationVariables,
  response: CloseAccountMutationResponse,
|};
*/


/*
mutation CloseAccountMutation(
  $accountId: ID!
) {
  closeAccount(accountId: $accountId) {
    account {
      id
      updatedAt
      clientaccount {
        id
        accountStatus
        updatedAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "accountId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "closeAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "CloseAccountAdmin",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "account",
        "storageKey": null,
        "args": null,
        "concreteType": "AccountNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "clientaccount",
            "storageKey": null,
            "args": null,
            "concreteType": "ClientAccountNode",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountStatus",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CloseAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CloseAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CloseAccountMutation",
    "id": null,
    "text": "mutation CloseAccountMutation(\n  $accountId: ID!\n) {\n  closeAccount(accountId: $accountId) {\n    account {\n      id\n      updatedAt\n      clientaccount {\n        id\n        accountStatus\n        updatedAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0e4861a0fd429dc621f5863997aaeff5';
module.exports = node;
